(function () {
  var grid = document.querySelector('.hb-testimonials__grid');
  if (!grid) return;

  var INTERVAL_MS = 2000;
  var timer = null;
  var stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isSliderMode() {
    return grid.scrollWidth > grid.clientWidth + 1;
  }

  function advance() {
    if (stopped || !isSliderMode()) return;
    var card = grid.querySelector('.hb-testimonial');
    if (!card) return;
    var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).gap) || 0);
    var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
    if (atEnd) {
      grid.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      grid.scrollBy({ left: step, behavior: 'smooth' });
    }
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    if (stopped || !isSliderMode()) return;
    timer = setInterval(advance, INTERVAL_MS);
  }

  function haltPermanently() {
    stopped = true;
    stop();
  }

  // Once the visitor touches/drags it themselves, stop auto-advancing for good.
  grid.addEventListener('pointerdown', haltPermanently, { passive: true });

  // Mouse users (trackpad, external pointer on a tablet) get a hover-pause instead.
  grid.addEventListener('mouseenter', stop);
  grid.addEventListener('mouseleave', start);

  window.addEventListener('resize', function () {
    if (!isSliderMode()) {
      stop();
    } else if (!stopped) {
      start();
    }
  });

  start();
})();
